import ProcessRequestsInterceptor from '@src/helpers/interceptors/ProcessRequestInterceptor';

const _formflowService: ProcessRequestsInterceptor = new ProcessRequestsInterceptor()

const getProcesses = async (unit: string, filter?: any) => {
  let data: any = []
    data = await _formflowService.paging({
      unit: unit,
      to: undefined,
      from: undefined,
      limit: 100,
    }, ['id', 'name', 'paths', 'sections']);
  
  return data;
}

export default getProcesses


